module.exports = __webpack_public_path__ + "img/hero-lg.fd2f3173.png";